module.exports = __webpack_public_path__ + "img/chanpin.2bfa1cee.png";